(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tb-ui-react/scroll-top/assets/scroll-top-on-nav.js') >= 0) return;  svs.modules.push('/components/tb-ui-react/scroll-top/assets/scroll-top-on-nav.js');
'use strict';

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
const _React = React,
  useState = _React.useState;
const _ReactRouterDOM = ReactRouterDOM,
  useLocation = _ReactRouterDOM.useLocation;

const ScrollTopOnNav = _ref => {
  let children = _ref.children,
    _ref$shouldScrollOnLo = _ref.shouldScrollOnLoad,
    shouldScrollOnLoad = _ref$shouldScrollOnLo === void 0 ? true : _ref$shouldScrollOnLo;
  const location = useLocation();
  const _useState = useState(shouldScrollOnLoad ? '' : location.pathname),
    _useState2 = _slicedToArray(_useState, 2),
    path = _useState2[0],
    setPath = _useState2[1];
  React.useEffect(() => {
    if (location.pathname !== path) {
      window.scrollTo(0, 0);
      setPath(location.pathname);
    }
  }, [location, path]);
  return children;
};
ScrollTopOnNav.propTypes = {
  children: PropTypes.node.isRequired,
  shouldScrollOnLoad: PropTypes.bool
};
svs.tb_ui_react.scrollTop.ScrollTopOnNav = ScrollTopOnNav;

 })(window);